import { Card, CardContent } from '@/components/ui/card'
import { CodeBlock } from '../CodeBlock'
import { useTranslation } from '@/hooks/useTranslation'

export const LaravelSection = () => {
	const { t } = useTranslation()
	
	return (
		<section id="laravel" className="mb-16">
			<h2 className="text-3xl font-bold text-gray-900 dark:text-gray-100 mb-6">
				{t('docs.laravel.title')}
			</h2>
			<Card className="shadow-sm dark:bg-gray-800/50">
				<CardContent className="pt-6">
					<p className="mb-4 text-gray-700 dark:text-gray-300">
						{t('docs.laravel.instruction.prefix')}{' '}
						<code className="bg-gray-200 dark:bg-gray-700 px-1 py-0.5 rounded text-xs">
							resources/views/layouts/app.blade.php
						</code>
						{t('docs.laravel.instruction.suffix')}
					</p>
					<CodeBlock
						language="php"
						copyLabel={t('docs.laravel.copyLabel')}
						copyMessage={t('docs.laravel.copyMessage')}
						code={`<!DOCTYPE html>
<html lang="{{ str_replace('_', '-', app()->getLocale()) }}">
<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>{{ config('app.name', 'Laravel') }}</title>
    @vite(['resources/css/app.css', 'resources/js/app.js'])
</head>
<body>
    @yield('content')
    
    <!-- Feedbask Widget -->
    <script
        defer
        src="https://cdn.feedbask.com/widget.js"
        data-client-key="{{ env('FEEDBASK_WIDGET_ID') }}"
        data-language="en"
        id="feedbask-widget-script"
    ></script>
</body>
</html>`}
					/>
					<div className="mt-4 p-4 bg-slate-50 dark:bg-slate-900/50 rounded-md">
						<p className="text-sm text-slate-700 dark:text-slate-300 mb-2">
							<strong>{t('docs.laravel.environmentConfig.title')}</strong>
						</p>
						<p className="text-sm text-slate-600 dark:text-slate-400">
							{t('docs.laravel.environmentConfig.instruction.prefix')}{' '}
							<code className="bg-gray-200 dark:bg-gray-700 px-1 py-0.5 rounded text-xs">
								.env
							</code>{' '}
							{t('docs.laravel.environmentConfig.instruction.suffix')}
						</p>
						<code className="block mt-2 p-2 bg-gray-100 dark:bg-gray-800 rounded text-xs font-mono">
							FEEDBASK_WIDGET_ID=your_actual_widget_id
						</code>
					</div>
				</CardContent>
			</Card>
		</section>
	)
}